import EditAccessProfile from './EditAccessProfile';

export default EditAccessProfile;
